// src/Footer.js
import React from 'react';
import { Link } from '@mui/material';
import { AppFooter } from "@colliers/colliers-b2c";
import { Icon } from "@mui/material";
class Footer extends React.Component {
    footerRight = () => {
        return (
            <>
                <Link target='_blank' href="https://www.linkedin.com/company/colliers" title=""><Icon className="fa-brands fa-linkedin" /></Link>
                <Link target='_blank' href="https://x.com/Colliers" title=""><Icon className="fa-brands fa-x-twitter" /></Link>
                <Link target='_blank' href="https://www.facebook.com/colliersinternational/" title=""><Icon className="fa-brands fa-facebook" /></Link>
                <Link target='_blank' href="https://www.instagram.com/colliersinternational/" title=""><Icon className="fa-brands fa-instagram" /></Link>
            </>
        )
    }
    footerCenter = () => {
        return (
            <>
                <Link target='_blank' href="/cookie-policy">Cookie Policy</Link>
                <Link target='_blank' href="/privacy-policy">Privacy Policy</Link>
                <Link target='_blank' href="/terms-of-use">Terms of Use</Link>
            </>
        )
    }

    render() {
        return (
            <AppFooter footerLeft="Copyright © 2026 Colliers International" footerRight={this.footerRight()} footerCenter={this.footerCenter()} />
        );
    }
}

export default Footer;